import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_LIEFERANTENSTAMM_RABATT } from '../lieferantenstamm.api';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierDiscount } from '../types/supplier-discount';

@Injectable()
export class LieferantenRabattRepository extends ReadonlyHttpApiListRepository<
  Result<SupplierDiscount[]>,
  LieferantenQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM_RABATT);
  }

  override getLoadPathParams(params: LieferantenQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
